import React, { useState } from 'react';

import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IInvoice } from 'src/types/invoice';
import { IStudent } from 'src/types/student';
//import InvoiceActionsColumn from './InvoiceActionsColumn';
import { CellProps } from 'react-table';

import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import OrderEnum from 'src/enumerables/order-enum';
import CaseEnum from 'src/enumerables/case-enum';
import GeneralEnum from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';

import dropdownFilter from 'src/components/react-table/filters/dropdown-filter';
import StatusInvoiceAction from './StatusInvoiceAction';

import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';
import styles from '../../../../../../Invoices/screens/InvoiceList/assets/invoice-grid.module.scss';
import InvoiceActionsColumn from './InvoiceActionsColumn';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import dateFilterMulti from '../../../../../../../../../components/react-table/filters/date-filter-multi';
import { numberWithCommas } from '../../../../../../../../../helpers/format';

interface Props {
    data: Paginated<Partial<IInvoice>>;
    students: Paginated<Partial<IStudent>>;
    getData: (params: QueryParams) => void;
    provider: string;
}

const InvoicesGrid: React.FunctionComponent<Props> = ({ data, getData, provider, students }: Props) => {
    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const caseEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(caseEnum);
    const statusEnum = GeneralEnum ? GeneralEnum.getEnum('InvoiceStatus') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const statuses: SelectObject[] = getValFromEnum(statusEnum);
    const [columns, setColumns] = useState<any>([]);
    const studentsValues: any = [];
    students.list.forEach((st: Partial<IStudent>) => {
        studentsValues.push({ value: st.id, label: `${st.firstName} ${st.lastName}` });
    });
    const getColumns = (studentsData: any): Column<Partial<IInvoice>>[] => [
        {
            Header: '#',
            accessor: 'id',
            disableSortBy: true,
            disableFilters: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => (
                <Link
                    className={'btn btn-info'}
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: provider,
                        tab: 'invoices-detail',
                        subId: original.id,
                    })}
                >
                    {original.id}
                </Link>
            ),
            Filter: textFilter<IInvoice>(),
        },

        {
            Header: 'Invoice Date',
            accessor: 'createdAt',

            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                const value = original.createdAt;
                return value ? `${changeToZeroMoment(value, 'MMM D, YYYY')}` : '';
            },
            Filter: dateTimeFilter<IInvoice>(),
        },

        {
            Header: 'Invoice Total',
            accessor: 'invoiceTotal',
            disableSortBy: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) =>
                original.invoiceTotal ? `$${numberWithCommas(original.invoiceTotal)}` : '$0.00',
            disableFilters: true,
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'Case Number',
            disableSortBy: true,
            disableFilters: true,
            accessor: 'occasion.id',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => (
                <Link
                    to={Router.generate(routes.CASE_EDIT, {
                        id: original?.occasion?.id,
                    })}
                >
                    {original.occasion?.caseNumber}
                </Link>
            ),
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'Student',

            accessor: 'student.id',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                if (!original?.student) return '';

                return (
                    <Link
                        to={Router.generate(routes.STUDENT_DETAIL, {
                            id: original?.student?.id,
                            tab: 'student-info',
                        })}
                    >
                        {`${original.student?.firstName} ${original.student?.lastName}`}
                    </Link>
                );
            },
            Filter: dropdownFilter<IInvoice>(studentsData),
        },
        {
            Header: 'Vendor',
            disableSortBy: true,
            disableFilters: true,
            accessor: 'vendor.id',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                if (!original?.vendor) return '';

                return (
                    <Link
                        to={Router.generate(routes.VENDOR_DETAIL, {
                            id: original?.vendor?.id,
                        })}
                    >
                        {`${original.vendor?.name}`}
                    </Link>
                );
            },
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'District',
            disableSortBy: true,
            disableFilters: true,
            accessor: 'district.id',

            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                if (!original?.district) return '';

                return (
                    <Link
                        to={Router.generate(routes.DISTRICT_DETAIL, {
                            id: original?.district?.id,
                        })}
                    >
                        {`${original.district?.name}`}
                    </Link>
                );
            },
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'Service Type',
            accessor: 'updatedAt',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                let title = original.occasion?.serviceType?.title;
                if (!title) {
                    title = original.occasion?.serviceType?.cpt;
                }

                return <div>{title}</div>;
            },
            disableSortBy: true,
            disableFilters: true,
            Filter: textFilter<IInvoice>(),
        },

        {
            Header: 'Service Period',
            accessor: 'periodStart',
            disableSortBy: true,

            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                const valueOrderType = original.periodStart;
                const monthStart = changeToZeroMoment(valueOrderType, 'M');
                const monthEnd = changeToZeroMoment(original.periodEnd, 'M');
                const YearStart = changeToZeroMoment(valueOrderType, 'YYYY');
                const YearEnd = changeToZeroMoment(original.periodEnd, 'YYYY');
                let yearDate = changeToZeroMoment(valueOrderType, 'YYYY');
                if (YearStart !== YearEnd) {
                    yearDate = `${changeToZeroMoment(valueOrderType, 'YYYY')}-${changeToZeroMoment(
                        valueOrderType,
                        'YY',
                    )}`;
                }
                if (monthStart === monthEnd) {
                    return valueOrderType ? (
                        <div className={'text-center'}>{`${changeToZeroMoment(valueOrderType, 'MMM D, YYYY')}`}</div>
                    ) : (
                        ''
                    );
                } else {
                    return valueOrderType ? (
                        <div className={'text-center'}>{`${changeToZeroMoment(
                            valueOrderType,
                            'MMM',
                        )} ${changeToZeroMoment(original.periodEnd, 'MMM')} - ${changeToZeroMoment(
                            valueOrderType,
                            ' D, ',
                        )} ${yearDate}`}</div>
                    ) : (
                        ''
                    );
                }
            },
            headerClassName: 'text-center w-100 d-block',
            Filter: dateFilterMulti<IInvoice>(),
        },
        {
            Header: 'Case Type',
            accessor: 'caseType.id',
            disableSortBy: true,
            disableFilters: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                const valueCaseType = caseTypes.find((it) => +it.value === original.occasion?.caseType);
                return valueCaseType ? valueCaseType.label : '';
            },
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'Order Type',
            accessor: 'orderType.id',
            disableSortBy: true,
            disableFilters: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                const valueOrderType = orderTypes.find((it) => it.value === original.occasion?.orderType);
                return valueOrderType ? valueOrderType.label : '';
            },
            Filter: textFilter<IInvoice>(),
        },

        {
            Header: 'Note',
            accessor: 'note',
            disableSortBy: true,
            disableFilters: true,
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'Payment or Credit Appliance',
            accessor: 'payment',
            disableSortBy: true,
            disableFilters: true,
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                let paymentIds: number[] = [];
                original.paymentInvoices.forEach((it: any) => {
                    paymentIds.push(+it?.payment.id);
                });
                const newSet: any = new Set(paymentIds);
                paymentIds = [...newSet];
                return paymentIds.map((it: number) => {
                    return (
                        <Link
                            className={'mr-1'}
                            style={{ borderBottom: '1px solid #d1d1d1', paddingBottom: 1 }}
                            to={Router.generate(routes.PAYMENT_DETAIL, {
                                id: it,
                            })}
                        >
                            {`${it}`}
                        </Link>
                    );
                });
            },
            Filter: textFilter<IInvoice>(),
        },
        {
            Header: 'Status',
            accessor: 'status',
            width: '15%',
            Cell: ({
                cell: {
                    row: { original },
                },
            }: CellProps<IInvoice>) => {
                return <StatusInvoiceAction data={original} />;
            },
            Filter: dropdownFilter<IInvoice>(statuses, styles.minWidth),
        },
        {
            Header: 'Action',
            accessor: 'isWeekly',

            disableSortBy: true,
            disableFilters: true,
            Cell: InvoiceActionsColumn,
        },
    ];
    if (!columns.length && studentsValues.length) {
        setColumns(getColumns(studentsValues));
    }
    return (
        <div>
            <Grid<Partial<IInvoice>> columns={columns} data={data} getData={getData} />
        </div>
    );
};

export default InvoicesGrid;
